import React from 'react';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import COLORS from '@mlb/react-patterns/style/universal.color';

import { useDictionary } from 'bdvp-common/src/hooks/config';

const Component = styled.div`
    color: ${COLORS.mlbGrey3};
    font-size: 11px;
    padding-top: 35px;
    line-height: normal;
    text-align: center;

    ${media.mdmin`
        font-size: 14px;
        padding-top: 20px;
    `}
`;

const TrimInfo = () => {

    const {
        clip_trimming_info: clipTrimmingInfo = 'Clips can be trimmed based on the increments shown on the progress bar above. Increments are typically about 6 seconds.',
    } = useDictionary();

    return <Component>{clipTrimmingInfo}</Component>;

};

export default TrimInfo;
